async function axiosWithRetry<T>(callback: () => Promise<any>, retries = 3, delay = 1000): Promise<T> {
  for (let attempt = 0; attempt <= retries; attempt++) {
    const response = await callback();
    const responseData = response.data?.data;
    if (!responseData.scanComplete && attempt < retries) {
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      await new Promise((res) => setTimeout(res, delay * (attempt + 1)));
    } else {
      return response.data?.data as T;
    }
  }
  return { fileSafe: false, scanComplete: true } as T;
}

export default axiosWithRetry;
